import {Platform, Text} from 'react-native';
import styled from 'styled-components';

const BigBoldBlueTextStyle = {
  fontWeight: 700,
  fontFamily: 'IRANSans',
};

const BigBoldBlueTextStyleAndroid = {
  ...BigBoldBlueTextStyle,
  fontSize: 28,
};

const BigBoldBlueTextStyleWeb = {
  ...BigBoldBlueTextStyle,
  fontSize: 18,
  marginBottom: 5,
};

export const BigBoldBlueTextElem =
  Platform.OS === 'android' || Platform.OS === 'ios'
    ? styled(Text)`
        ${BigBoldBlueTextStyleAndroid}
      `
    : styled.p`
        color: ${({theme}) => theme.colors.text.base};
        ${BigBoldBlueTextStyleWeb}
      `;

export const BigBoldBlueTextInlineElem =
  Platform.OS === 'android' || Platform.OS === 'ios'
    ? styled(Text)`
        color: ${({theme}) => theme.colors.text.base};
        ${BigBoldBlueTextStyle},
      `
    : styled.span`
        color: ${({theme}) => theme.colors.text.base};
        ${BigBoldBlueTextStyle}
      `;
